/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsInCardinal(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M161.94141,182.627a8.00066,8.00066,0,0,1-5.65723,13.65723H136V232a8,8,0,0,1-16,0V196.28418H99.71582A8.00066,8.00066,0,0,1,94.05859,182.627l28.28418-28.28418a8.003,8.003,0,0,1,11.31446,0Zm-39.59864-80.96972a8.00181,8.00181,0,0,0,11.31446,0l28.28418-28.28418a8.00066,8.00066,0,0,0-5.65723-13.65723H136V24a8,8,0,0,0-16,0V59.71582H99.71582a8.00066,8.00066,0,0,0-5.65723,13.65723Zm-20.68554,20.68554L73.37305,94.05859a8.00066,8.00066,0,0,0-13.65723,5.65723V120H24a8,8,0,0,0,0,16H59.71582v20.28418a8.00053,8.00053,0,0,0,13.65723,5.65723l28.28418-28.28418A8.00122,8.00122,0,0,0,101.65723,122.34277ZM232,120H196.28418V99.71582A8.00066,8.00066,0,0,0,182.627,94.05859l-28.28418,28.28418a8.00122,8.00122,0,0,0,0,11.31446L182.627,161.94141a8.00066,8.00066,0,0,0,13.65723-5.65723V136H232a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default ArrowsInCardinal;
